import { OrderConfirmation } from '@/modules/perseo-billing/containers';

export const PerseoBillingOrderConfirmation = () => {
  return (
    <div id="perseo-billing" className="co-w-screen">
      <div id="perseo">
        <OrderConfirmation />
      </div>
    </div>
  );
};
